import ComponentBase from "./componentBase";

export default abstract class ModalBase extends ComponentBase{
    protected modalBody:HTMLElement;

    constructor(
        protected modalTitle:string,
        protected container:HTMLElement,
        protected idModal:string,
        protected elementToRender:string
    ){
        super(container,idModal,elementToRender);
    }

    render(){
        return super.renderWithCB((c,e)=>{
            this.modalBody = this.elementRendered.querySelector(".modal-body");
            this.close();
        });
    }

    public show(){
        this.elementRendered.classList.remove("d-none");
    }

    private close(){
        this.elementRendered.querySelector(".modal-closer").addEventListener("click",()=>{
            //this.onClose()
        });
    }

    public onClose(){
        this.elementRendered.classList.add("d-none");
    }

    abstract loadBody(cb:()=>void):void;

}